import { render } from "./CriarProtocolo.vue?vue&type=template&id=b0a01d2c"
import script from "./CriarProtocolo.vue?vue&type=script&lang=js"
export * from "./CriarProtocolo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__